import CancelIcon from '@mui/icons-material/Cancel';
import { InputBase, styled } from '@mui/material';

export const Search = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderRadius: '20px',
  padding: '4px 23px',
  gap: '20px',
  backgroundColor: '#004763',
  '&:hover': {
    backgroundColor: '#265D7C'
  }
});

export const IconWrapper = styled('div')({
  height: '100%',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.with-pointer-events': {
    pointerEvents: 'auto'
  },
  '&:hover': {
    color: '#1EB9FB'
  },
  '&:focus-visible': {
    border: '2px solid #1EB9FB',
    borderRadius: '5px',
    outline: 'none'
  }
});

export const StyledInputBase = styled(InputBase)({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    width: '100%',
    '&::placeholder': {
      color: '#D5D9DD',
      opacity: 1
    }
  }
});

export const StyledCancelIcon = styled(CancelIcon)({
  color: '#80979F',
  '&:hover': {
    color: '#1EB9FB'
  }
});
